import React from 'react';
import Reflux from 'reflux';
import FormItemContainer from './FormItemContainer';

import FormItemUtil from '../utils/FormItemUtil';

class FormItemTabPage extends FormItemContainer
{

	constructor(props) 
	{
		super(props);
	}

	
	getStyle()
	{
		let layout = this.props.xml.Properties.Layout.Value;
		let parentLayout = this.props.parentLayout;
		let _flexDirection = (layout=="horizontal"?"row":"column");
		let style = {
			flexDirection:_flexDirection,
			alignItems:"flex-start",
			flex:'none'
	    };
	    style["display"] = this.props.visible?"flex":"none";
	    //chrome浏览器在某一父节点没有采用百分比的情况下 子节点设置百分比无效无效 
	    //所以采用flex布局
	   	//style["height"] = "100%";
	   	style["flexGrow"] = 100;
	   	style["overflow"] = 'auto';

	   	/*if(this.props.heightFromTab!=undefined)
	   		style["height"] = this.props.heightFromTab+"px";
		else
			alert(35345435);*/
		return style;
	}

	getPageDiv()
	{
		return this.pageDiv;
	}

	componentDidMount()
	{
		$(this.pageDiv).contextPopup(this.props.contextMenuData);
	}

	//更新显示隐藏由Tab统一处理
	onCmdUpdateControlVisible(menuItemId,formId,names,isLookup)
	{
	}

	render()
	{
		let parent = this.props.xml;
		let children = parent.FormItem;
		let layout = parent.Properties.Layout.Value;
		let _className = "tab-pane";//this.props.visible?"tab-pane":"tab-pane active";
		let that = this;
		let list = children.map(function(item) {
			return FormItemUtil.getFormItemInstance(that.props.menuItemId,that.props.formId,item,parent,that.props.forLookup);
        });
		
		var _style = this.getStyle();
		//_style.display = this.props.visible?"flex":"none";
		return (<div data-index={this.props.xmlChildIndex} ref={node => this.pageDiv = node} className={"FormItemTabPage "+_className} id={this.props.xml.name} style={_style}>{list}</div>);
	}
};

FormItemTabPage.defaultProps = {
};

export default FormItemTabPage;




// WEBPACK FOOTER //
// ./src/formItem/FormItemTabPage.js